import hasDuplicated from '../functions/hasDuplicated';
import in_array from 'in_array';

const template = require('lodash/template');
const makeSelectize = require('../functions/makeSelectize.js');
const AtualizaInputs = require('./AtualizaInputs');
const to_array = require('to_array');
const Lang = require('lang');

function UsuarioAprovadorInput(container, json, usuariosDoFluxo) {
  const $container = $(container);
  const template_string = $('#usuario-aprovador').html().replace(/&gt;/g, '>').replace(/&lt;/g, '<');
  const _template = template(template_string);
  const inputSelector = 'select[name^="usuarios"]';

  if (!$container.length) {
    return;
  }

  let count = 0;
  let idUsuario = 0;

  /**
   * Validação de repetição de usuários no fluxo de aprovação
   */
  $container.on('change', inputSelector, function(event) {
    const selectize = event.target.selectize;
    const inputs = to_array(document.querySelectorAll(inputSelector));
    const usuarios = inputs.map(input => Number(input.value)).filter(Boolean);
    if (hasDuplicated(usuarios)) {
      const usuario = selectize.options[selectize.getValue()].text;

      bootbox.alert({
        title: Lang.get('js/src/fluxos-aprovacao/UsuarioAprovadorInput.user_not_allowed'),
        message: Lang.get('js/src/fluxos-aprovacao/UsuarioAprovadorInput.user_cannot_be_approver_twice', {user: usuario}),
        size: 'small',
        closeButton: false
      });

      selectize.clear(true);
    }
  });

  /**
   * Validação de usuário que é aprovado pelo fluxo
   */
  $container.on('change', inputSelector, function(event) {
    const selectize = event.target.selectize;

    if(usuariosDoFluxo) {
      const usuarios = usuariosDoFluxo.map(usuario => usuario.id);
      if(in_array(selectize.getValue(), usuarios)) {
        const usuario = selectize.options[selectize.getValue()].text;

        bootbox.alert({
          title: Lang.get('js/src/fluxos-aprovacao/UsuarioAprovadorInput.user_not_allowed'),
          message: Lang.get('js/src/fluxos-aprovacao/UsuarioAprovadorInput.user_cannot_be_approver_same_flow', {user: usuario}),
          size: 'small',
          closeButton: false
        });

        selectize.clear();
      }
    }

  });

  $container.parent().on('click', '.add', function(event, jsonUsuario) {
    const grupo = this.dataset.grupoId;
    const etapa = this.dataset.etapaId;
    const condicaoNeto = $('[name="condicaoNeto[' + etapa + '][' + grupo + ']"]').val();

    count++;
    idUsuario++;

    $('#usuarios-aprovadores-' + etapa + '-' + grupo).append(_template({
      etapa: etapa,
      grupo: grupo,
      usuario: idUsuario
    }));
    $('[name="condicaoNeto[' + etapa + '][' + grupo + ']"]').val(condicaoNeto);

    const usuario_string = '[name="usuarios[' + etapa + '][' + grupo + '][' + idUsuario + ']"]';

    makeSelectize(usuario_string, null, false, 1);

    if (jsonUsuario) {
      document.querySelector(usuario_string)
        .selectize
        .setValue(jsonUsuario.idUsuarioAprovador, true);
    }

    AtualizaInputs.init();
  });

  $container.on('click', '.remove', function(e) {
    if (count <= 1) {
      return false;
    }

    count--;

    $(this).closest('.js-usuario-aprovador').remove();
  });

  if (json) {
    json.forEach(function(item, n) {
      $container.parent().find('.add').trigger('click', [item]);
    });
  }
}

module.exports = UsuarioAprovadorInput;

